var getEasedStaggerDelayForTransitionOut = function (index, length) {
	//
	var toAdd = 500 / length
	// if (length > 20) {
	// 	toAdd = 25
	// }

	var normalDelay = index * toAdd
	var maxDelay = length * toAdd

	var mappedVal = map(normalDelay, 0, maxDelay, 0, 1)
	var easedVal = easeOutQuart(mappedVal)
	var val = normalDelay * easedVal

	return val
}
var getEasedStaggerDelayForTransitionIn = function (index, length) {
	//
	var toAdd = 500 / length
	// if (length > 20) {
	// 	toAdd = 25
	// }

	var normalDelay = index * toAdd
	var maxDelay = length * toAdd

	var mappedVal = map(normalDelay, 0, maxDelay, 0, 1)
	var easedVal = easeOutQuart(mappedVal)
	var val = normalDelay * easedVal

	return val
}

// New stagger formula — matches the Build Animation modal's
// `computeTimings` so the inter-element gap is an explicit knob
// (`staggerMs`) instead of the legacy `500 / length` budget. With
// `staggerMs = 100` and 13 cols, gaps land around ~80-130ms (sin-eased),
// vs ~19ms with the legacy formula → cascade is actually perceivable.
//
//   delay(i) = sampleEasing(easing, i/(n-1)) * staggerMs * (n-1)
//
// Easing is one of a small allowlist (easeOutSine default — same as the
// Build Animation modal default); unknown names fall back to linear.
//
// Use this for new stagger cascades (nav-anim transition_in/out, sync
// controller, UI fades). The legacy `getEasedStaggerDelayForTransitionIn`
// is kept untouched for callers that haven't migrated yet.
var getStaggerDelayMs = function (index, length, staggerMs, easingName) {
	if (length <= 1) return 0
	var n = length
	var i = Math.max(0, Math.min(n - 1, index))
	var tLinear = i / (n - 1)
	var tEased = sampleStaggerEasing(easingName, tLinear)
	var budget = Math.max(0, Number(staggerMs) || 0) * (n - 1)
	return tEased * budget
}

// Stagger-easing allowlist — mirrors the Build Animation modal's
// `easingFunctions` table. Keep in sync with
// gridder/tsx/util/buildSequentialAnimation.ts so editor preview and
// runtime use the same curve.
var STAGGER_EASINGS = {
	linear: function (t) { return t },
	easeInQuad: function (t) { return t * t },
	easeOutQuad: function (t) { return t * (2 - t) },
	easeInOutQuad: function (t) { return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t },
	easeInCubic: function (t) { return t * t * t },
	easeOutCubic: function (t) { var x = t - 1; return x * x * x + 1 },
	easeInOutCubic: function (t) { return t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1 },
	easeInQuart: function (t) { return t * t * t * t },
	easeOutQuart: function (t) { return easeOutQuart(t) },
	easeInOutQuart: function (t) { var x = t - 1; return t < 0.5 ? 8 * t * t * t * t : 1 - 8 * x * x * x * x },
	easeInSine: function (t) { return 1 - Math.cos((t * Math.PI) / 2) },
	easeOutSine: function (t) { return Math.sin((t * Math.PI) / 2) },
	easeInOutSine: function (t) { return -(Math.cos(Math.PI * t) - 1) / 2 },
	easeInExpo: function (t) { return t === 0 ? 0 : Math.pow(2, 10 * (t - 1)) },
	easeOutExpo: function (t) { return t === 1 ? 1 : 1 - Math.pow(2, -10 * t) },
}

var sampleStaggerEasing = function (name, t) {
	var fn = STAGGER_EASINGS[name] || STAGGER_EASINGS.easeOutSine
	var clamped = Math.max(0, Math.min(1, t))
	return fn(clamped)
}

// Per-element duration scaling mirror of the Build Animation modal's
// `scalePerElementDuration` checkbox. Late-starting cols animate longer
// (140% of base) and early ones shorter (60%) so the cascade's finish
// order matches the start order regardless of easing.
// Returns the BASE duration multiplied by the scale factor.
var getStaggerScaledDurationMs = function (index, length, baseDurationMs, easingName) {
	if (length <= 1) return baseDurationMs
	var n = length
	var i = Math.max(0, Math.min(n - 1, index))
	var tEased = sampleStaggerEasing(easingName, i / (n - 1))
	var scale = 0.6 + tEased * 0.8
	return Math.max(1, baseDurationMs * scale)
}
// https://github.com/AndrewRayCode/easing-utils/blob/master/src/easing.js
// pass in a value between 0 and 1, and get the eased value back

// Decelerating to zero velocity
function easeOutQuart(t) {
	const t1 = t - 1
	return 1 - t1 * t1 * t1 * t1
}

function map(value, in_min, in_max, out_min, out_max) {
	return ((value - in_min) * (out_max - out_min)) / (in_max - in_min) + out_min
}

export { getEasedStaggerDelayForTransitionOut, getEasedStaggerDelayForTransitionIn, getStaggerDelayMs, getStaggerScaledDurationMs }
